import { render, staticRenderFns } from "./register-inner.vue?vue&type=template&id=6fb2a8d0"
import script from "./register-inner.vue?vue&type=script&lang=js"
export * from "./register-inner.vue?vue&type=script&lang=js"
import style0 from "./register-inner.vue?vue&type=style&index=0&id=6fb2a8d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports